/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import RoomEvent from '../../event/RoomEvent'

const _SettingInfoState = {
  edited: false,
  channelManager: null
}

class SettingInfoState extends Record(_SettingInfoState) {
  setChannelManager(room) {
    let channelManager = 'none'
    if (room.beds24_api_key && room.beds24_prop_key) {
      channelManager = 'beds24'
    } else if (room.neppan_userid && room.neppan_password) {
      channelManager = 'neppan'
    }
    return this.merge({ channelManager: channelManager })
  }
}

class SettingInfoStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new SettingInfoState()
  }

  reduce(state, action) {
    const payload = action.payload
    switch (action.type) {
      case RoomEvent.fetchOne:
        return state.clear().setChannelManager(payload.room)

      case RoomEvent.onEdit:
        return state.merge({ edited: true })

      case RoomEvent.onEditChannelManager:
        return state.merge({ edited: true, channelManager: payload.value })

      default:
        return state
    }
  }
}

export default new SettingInfoStore()
